<template>
  <div class="user-wrp-comments">
    <div class="result-bracket__title user__list-count">
      <!-- <span class="result-bracket__count" v-if="comments.length !== 0" >{{ comments.length }} </span> Yorum Bulundu ! -->

      <span class="result-bracket__count">{{ lists.length }} </span> Lists Found !

    </div>
          <div class="right-block mypointer" v-on:click="createList()">
            <p class="user-settings__profil-name">
            <p class="exit-text" >Create List</p>
            <p>
              <span class="sign-out" >
                <svg-icon type="icon-sign-out"/>
              </span>
            </p>
          </div>
    <empty-content :content="emptyContent" v-if="lists.length === 0"/>

    <div class="user__list-offer">
      <div class="user__list-offer__item" v-for="list in lists" :key="list.id">
        <div class="user__list-comment-wrp">
          <div class="user__list__dorm">
            <div class="user__list__dorm-img-wrp mycursor" v-on:click="openMovie(list.name, list.id)" v-if="list.logo">
              <img :src="list.logo" class="user__list__dorm-img" alt="">
            </div>
            <div class="user__list__dorm-wrp mycursor" v-on:click="openMovie(list.name, list.id)" >
              <p class="user__list__dorm-name">{{ list.name }}</p>
              <span class="user__list__dorm-location">
                 <img class="user__list__dorm-location-svg" src="@/assets/img/pin.svg"/>
                {{ list.description }}, {{ list.list_type }}</span>
            </div>
          </div>
          <p class="user__list-date"> {{ list.favorite_count }}</p>
        </div>
        <div class="user__list-comment">
          {{ list.comment }}
<!--           <div class="user__list-link">
            <span class="comment-ico">
               <svg-icon type="icon-enter"/>
            </span>
            YORUMU GÖR
          </div> -->
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EmptyContent from '@/components/EmptyContent'
export default {
  name: 'Offers',
  components: {
    EmptyContent,
    },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'My Lists',
      link: [
        { rel: 'canonical' },
        { href: window.location.origin + '/user-management/comments' }
      ] 
    }
  },     
  data () {
    return {
      errors: [],
      lists: [],
      emptyContent: {
        icon: 'icon-search',
        title: 'No results!',
        text: 'Create your lists, add movies and sahre with your friends !!'
      },
    }
  },
  methods: {
    createList () {
      let self = this
      const session_id = window.localStorage.getItem('session_id')
      axios.post(`/3/list?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}`,{
        name: "This is my awesome test list.",
        description: "Just an awesome list dawg.",
        language: "en"
          }
      
      )
        .then(response => {
          self.lists = response.data.results/*
          self.comments.forEach((item) => {
            const str = item.created_at.split(':')
            item.created_at = str[0] + ':' + str[1]
      })*/
        })
        .catch(e => {
          self.errors.push(e)
        })
    },    
    openMovie (name, id) {
      window.localStorage.setItem('dormid', id)
      const slug = this.string_to_slug(name)
      window.open(window.location.origin + '/' + slug + '-y-' + id, '_blank')
    },
    string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, '') // trim
        str = str.toLowerCase()
  
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
        var to   = "aaaaeeeeiiiioooouuuunc------"
        for (var i=0, l=from.length ; i < l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-') // collapse dashes

        return str
    },    
    getComments () {
      let self = this
      const session_id = window.localStorage.getItem('session_id')
      axios.get(`/3/account/{account_id}/lists?api_key=a11ac97c6bdb99adc0845654be0902a8&session_id=${session_id}&language=en-US&sort_by=created_at.asc&page=1`)
        .then(response => {
          self.lists = response.data.results
        })
        .catch(e => {
          self.errors.push(e)
        })
    },    
  },
  mounted () {
    this.getComments()
  },    
}
</script>

<style lang="scss">
  @import "../assets/scss/components/comments";
    .mycursor { 
    cursor: pointer; }
</style>
